"use client";

import { useEffect } from "react";

/**
 * The client boundary: a crash here never reaches the server, so the page that
 * replaces it is also what reports it. Production hands the browser a digest
 * and a generic message — the digest is what ties this row to the server one.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    navigator.sendBeacon?.(
      "/api/errors",
      new Blob(
        [
          JSON.stringify({
            message: error.message,
            stack: error.stack,
            digest: error.digest,
            path: location.pathname,
          }),
        ],
        { type: "application/json" },
      ),
    );
  }, [error]);

  return (
    <main style={{ padding: "48px 24px", maxWidth: 560, margin: "0 auto" }}>
      <h1 style={{ fontSize: 22, fontWeight: 600 }}>Something broke</h1>
      <p style={{ marginTop: 8, opacity: 0.7 }}>
        It has been logged. {error.digest ? <code>{error.digest}</code> : null}
      </p>
      <button type="button" onClick={reset} style={{ marginTop: 16 }}>
        Try again
      </button>
    </main>
  );
}
